import $ from 'jquery'
import '../vendor/jquery.magnific-popup.js'

class Lollipop {
  constructor(el) {
    this.el = el
    this.opened = false
    this.toggler = el.querySelector('.candy')
    this.heading = el.querySelector('h3')

    if (el.classList.contains('accordion')) {
      this.toggler.addEventListener('click', () => this.toggle())
      this.heading.addEventListener('click', () => this.toggle())
    }

    if (el.classList.contains('popup')) {
      console.log('popup')

      $(this.el).find('h3, .candy').on('click', () => {
        $.magnificPopup.open({
          callbacks: {
            change: function () {
              const popups = $('.candy')

              $(this.content).find('.goto1').on('click', (e) => {
                e.preventDefault()
                $(popups[0]).trigger('click')
              })

              $(this.content).find('.goto2').on('click', (e) => {
                e.preventDefault()
                $(popups[1]).trigger('click')
              })

              $(this.content).find('.goto3').on('click', (e) => {
                e.preventDefault()
                $(popups[2]).trigger('click')
              })
            }
          },
          items: {
            src: '<div class="white-popup">' + this.el.querySelector('.popup').innerHTML + '</div><div class="mfp-close"></div>',
            type: 'inline'
          }
        })
      })
    } else {
      console.log('no popup')
    }
  }

  open() {
    this.el.classList.add('opened')
    this.opened = true
  }

  close() {
    this.el.classList.remove('opened')
    this.opened = false
  }

  toggle() {
    if (this.opened) {
      this.close()
    } else {
      this.open()
    }
  }
}

export default Lollipop


// WEBPACK FOOTER //
// ./js/classes/lollipop.class.js